import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericValue } from '../../core/model/generic-value';

import { HisBackendService } from '../../core/service/backend/his-backend.service';

@Injectable({providedIn: 'root'})
export class HisDocumentMetadataCategoryService {
    private backendService = inject(HisBackendService);


    /**
     * @returns an observable of GenericValue[]
     */
    public getDocumentMetadataCategories(): Observable<GenericValue[]> {
        return this.backendService.getData( 'api/v1/cs/sys/fileupload/documentMetadataCategories' );
    }

}
